import {Container, ThemeProvider} from '@mui/material';
import defaultTheme from '../components/Themes/defaultTheme';
import "../assets/css/main.css"
import { Box, Button, Divider, Link, Typography } from '@mui/material/node';

const Section = ({ title, children }) => (
  <Box sx={{ mb: 4 }}>
    <Typography variant="h5" gutterBottom>
      {title}
    </Typography>
    <Divider sx={{ mb: 2 }} />
    {children}
  </Box>
);

export const PrivacyPolicy = () => {
  return (
    <>
    <ThemeProvider theme={defaultTheme}>
      <Container disableGutters maxWidth="lg" component="main" sx={{ pt: 5, pb: 6, px: 3 }}>
        <Button onClick={() => window.location.href = 'https://nodecanvas.app'}>Back</Button>
        <Typography variant="h3" gutterBottom>
        Privacy Policy
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
        Last updated: January 2026
      </Typography>

      <Typography paragraph>
        Welcome to <strong>NodeCanvas</strong>. This Privacy Policy explains how
        we collect, use, disclose, and protect personal data when you use our
        website and SaaS application available at{" "}
        <Link href="https://nodecanvas.app" target="_blank" rel="noopener">
          https://nodecanvas.app
        </Link>{" "}
        (the “Service”).
      </Typography>

      <Typography paragraph>
        This Policy is provided in accordance with Regulation (EU) 2016/679
        (General Data Protection Regulation – “GDPR”) and applicable Slovak and EU
        data protection laws.
      </Typography>

      <Section title="1. Data Controller">
        <Typography paragraph>
          The data controller responsible for processing your personal data is
          the operator of NodeCanvas, established in the Slovak Republic.
        </Typography>
        <Typography>
          Contact email:{" "}
          <Link href="mailto:contact@nodecanvas.app">
            contact@nodecanvas.app
          </Link>
        </Typography>
      </Section>

      <Section title="2. Personal Data We Collect">
        <Typography variant="subtitle1">Account and Identification Data</Typography>
        <Typography paragraph>Email address, username or display name.</Typography>

        <Typography variant="subtitle1">Payment and Billing Data</Typography>
        <Typography paragraph>
          Transaction identifiers, billing status, and payment confirmations.
          Payment card details are processed by third-party payment providers and
          are not stored by us.
        </Typography>

        <Typography variant="subtitle1">Technical and Usage Data</Typography>
        <Typography paragraph>
          IP address, device and browser information, log and security data, and
          usage statistics.
        </Typography>

        <Typography variant="subtitle1">User Content</Typography>
        <Typography paragraph>
          Data and content you voluntarily upload or create using the Service.
        </Typography>
      </Section>

      <Section title="3. Purposes and Legal Bases">
        <Typography paragraph>
          We process personal data only where permitted by law, based on:
        </Typography>
        <ul>
          <li>Performance of a contract (account access, billing)</li>
          <li>Legal obligations (tax and accounting)</li>
          <li>Legitimate interests (security, analytics, service improvement)</li>
          <li>Consent (marketing communications, if applicable)</li>
        </ul>
        <Typography>
          You may withdraw consent at any time without affecting prior lawful
          processing.
        </Typography>
      </Section>

      <Section title="4. Data Sharing">
        <Typography paragraph>
          We may share personal data with trusted third-party service providers,
          including hosting providers, authentication and database services,
          payment processors, analytics providers, and email delivery services.
        </Typography>
        <Typography>
          All processors are bound by GDPR-compliant Data Processing Agreements.
          We do not sell your personal data.
        </Typography>
      </Section>

      <Section title="5. International Data Transfers">
        <Typography paragraph>
          Some service providers may process data outside the European Economic
          Area (EEA). In such cases, transfers are protected by appropriate
          safeguards such as EU Standard Contractual Clauses.
        </Typography>
      </Section>

      <Section title="6. Data Retention">
        <Typography paragraph>
          Personal data is retained only as long as necessary:
        </Typography>
        <ul>
          <li>Account data: for the duration of the account</li>
          <li>Billing data: as required by law</li>
          <li>Logs and technical data: limited security-related periods</li>
        </ul>
        <Typography>
          Upon account deletion, data is deleted or anonymized unless retention is
          legally required.
        </Typography>
      </Section>

      <Section title="7. Your Rights Under GDPR">
        <ul>
          <li>Access your personal data</li>
          <li>Correct inaccurate data</li>
          <li>Request deletion</li>
          <li>Restrict or object to processing</li>
          <li>Data portability</li>
          <li>Withdraw consent at any time</li>
          <li>Lodge a complaint with a supervisory authority</li>
        </ul>
        <Typography>
          Requests can be sent by email and will be handled within 30 days.
        </Typography>
      </Section>

      <Section title="8. Security Measures">
        <Typography paragraph>
          We apply appropriate technical and organizational security measures,
          including encryption, access controls, and secure infrastructure.
          However, no system is completely secure.
        </Typography>
      </Section>

      <Section title="9. Children’s Privacy">
        <Typography paragraph>
          The Service is not intended for children under 16 years of age. If we
          become aware that personal data of a child has been collected, it will
          be deleted without delay.
        </Typography>
      </Section>

      <Section title="10. Changes to This Policy">
        <Typography paragraph>
          We may update this Privacy Policy from time to time. Updates will be
          published on this page with a revised effective date. Continued use of
          the Service constitutes acceptance of the updated Policy.
        </Typography>
      </Section>

      <Section title="11. Contact and Supervisory Authority">
        <Typography paragraph>
          If you have questions or concerns, contact us at{" "}
          <Link href="mailto:contact@nodecanvas.app">
            contact@nodecanvas.app
          </Link>
          .
        </Typography>
        <Typography>
          You also have the right to lodge a complaint with the Office for
          Personal Data Protection of the Slovak Republic.
        </Typography>
      </Section>
      </Container>
      </ThemeProvider>
    </>
  );
};